import { AuthenticateMethod } from "@medbillai/graphql-types";

/**
 * The token type returned by Stytch.
 * - magic_links: Used by our Email Magic Links product.
 * - oauth: Used by our OAuth product.
 * - oauth-native: Used for native sign in where the stytch.oauth.apple.start endpoint returns the authentication so we skip the front end stytch.oauth.authenticate and go straight to our /authenticate endpoint
 * - reset_password: Used by our Passwords product during the reset password flow.
 * - login: Used by our Passwords product during the reset flow as the alternative one click login.
 *
 * This is not exported from Stytch so we need to define it here.
 * @see https://stytch.com/docs/workspace-management/redirect-urls
 */
export type StytchTokenType =
  | "magic_links"
  | "oauth"
  | "oauth-native" // See explanation above
  | "reset_password"
  | "login";

export function mapStytchTokenTypeToAuthenticateMethod(
  tokenType?: StytchTokenType,
): AuthenticateMethod {
  switch (tokenType) {
    case "magic_links":
      return AuthenticateMethod.MAGIC_LINK;
    case "oauth":
      return AuthenticateMethod.OAUTH;
    case "oauth-native":
      return AuthenticateMethod.OAUTH;
    default:
      throw new Error(`Unsupported token type: ${tokenType}`);
  }
}
